// [SolabsForce] Avatar sem foto sempre no roxo Solabs, para lead, agente e
// empresa. O Chatwoot escolhia 1 de 6 cores pelo número de letras do nome: cor
// que não significava nada e parecia querer dizer algo. As variáveis vêm do
// tema (_solabs-theme.scss): a escala `blue` do Chatwoot é o roxo #7D19F3, com
// tons próprios no modo escuro.
export const SOLABS_AVATAR_COLORS = {
  bg: 'rgb(var(--blue-4))',
  text: 'rgb(var(--blue-9))',
  darkBg: 'rgb(var(--blue-4))',
  darkText: 'rgb(var(--blue-11))',
};
